// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "CardGroup-module--bx--text-truncate--end--nHIto";
export var bxTextTruncateFront = "CardGroup-module--bx--text-truncate--front--GKHFk";
export var cardGroup = "CardGroup-module--cardGroup--PQiDQ";